import type { App } from 'vue';

import EventEmitter from 'eventemitter3';

// declare module 'vue' { // doesn't work as expected, $emitter is shown as any
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $emitter: EventEmitter;
  }
}

export default {
  install(app: App) {
    const emitter = new EventEmitter();
    app.provide('emitter', emitter);

    // DEPRECATED
    // <script setup lang="ts">
    // import { getCurrentInstance } from 'vue';
    // const internalInstance = getCurrentInstance();
    // internalInstance.appContext.config.globalProperties.$emitter;
    app.config.globalProperties.$emitter = emitter;
  },
};
